import { IconButton, Typography } from 'seagull';
import { WideArrowBackward } from 'seagull/icons';
import { relationshipModel } from "../../../../models";
import styles from "./MobilePane.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MobilePane(_ref) {
  let {
    vendorDetails,
    hideBack,
    activeStepIndex,
    hideStepper,
    onBackClick,
    'data-testid': testid
  } = _ref;
  const vendorLogoUrl = relationshipModel.vendorLogoUrl({
    vendor: vendorDetails
  });
  if (hideStepper) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    "data-testid": testid && "".concat(testid, "-mobile"),
    children: [/*#__PURE__*/_jsx("div", {
      children: activeStepIndex > 0 && !hideBack && onBackClick ? /*#__PURE__*/_jsx(IconButton, {
        onClick: () => onBackClick(activeStepIndex - 1),
        "data-testid": testid && "".concat(testid, "-mobile-back-btn"),
        children: /*#__PURE__*/_jsx(WideArrowBackward, {})
      }) : null
    }), vendorLogoUrl ? /*#__PURE__*/_jsx("img", {
      className: styles.logoImg,
      src: vendorLogoUrl
    }) : /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph1",
      weight: "normal",
      children: relationshipModel.vendorName({
        vendor: vendorDetails
      })
    }), /*#__PURE__*/_jsx("div", {})]
  });
}